import ApiClient, { ApiUrl } from './ApiClient';
import { DocumentsPostData, DocuSignPostData, OnboardPutData, PharmacyPostData, PharmacyPostDataIPC } from './types';

export const post = {
	documents: async (data: DocumentsPostData) => {
		const client = await ApiClient.getInstance();
		const localToken = localStorage.getItem('onboardJWT') ?? '';
		return client.create('/documents', data, { params: { jwt: localToken } });
	},
	docusign: async (data: DocuSignPostData) => {
		const client = await ApiClient.getInstance();
		const localToken = localStorage.getItem('onboardJWT') ?? '';
		return client.create('/docusign', data, { params: { jwt: localToken } });
	},
	pharmacy: async (data: PharmacyPostData | PharmacyPostDataIPC) => {
		const client = await ApiClient.getInstance();
		const localToken = localStorage.getItem('onboardJWT') ?? '';
		return client.create('/pharmacies', data, { params: { jwt: localToken } });
	},
	upload: async (data: FormData) => {
		const client = await ApiClient.getInstance();
		const localToken = localStorage.getItem('onboardJWT') ?? '';
		return client.createWithFormData('/uploads', data, { params: { jwt: localToken } });
	},
	rest: {
		onboard: async (data: Partial<OnboardPutData>) => {
			const client = await ApiClient.getInstance();
			return client.create('/onboarding', data, undefined, undefined, ApiUrl.MARKETPLACE_REST);
		}
	}
};
